module.exports = __webpack_public_path__ + "img/manual-fuvest.d91d4c58.png";